import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, setLocale } from 'react-redux-i18n'
import moment from 'moment';

import { Modal, Form, Input, Button, Spin, Select, message, Switch,Space,Alert,DatePicker } from 'antd'
import { MinusCircleOutlined, EditOutlined, PlusOutlined, AppstoreAddOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest'
import SpinFull from '../../components/SpinFull'

const formLayout = {
  labelCol: {
    md: {span: 5},
    sm: {span: 24},
  },
  wrapperCol: {
    md: {span: 16},
  },
}

const formTailLayout = {
  wrapperCol: {
    md: {offset: 5, span: 16},
  },
}

const {TextArea} = Input
const {Option} = Select

export default function FamilyServiceAddModal (props) {
  const userData = useSelector(state => state.user.value)
  const {visible, onOk, onCancel,familyId} = props
  const user = useSelector(state => state.user.value)
  const [loaded, setLoaded] = useState(false)
  const [loading, setLoading] = useState(false)
  const [services, setServices] = useState(null)
  const [serviceOptions, setServiceOptions] = useState(false)
  const [form] = Form.useForm();

  useEffect(() => {
    (async () => {
      try {
        const serviceRes = await ToolRequest.request('GET', `/service`)
        setServices(serviceRes.data)
        const options = serviceRes.data.map(item => {
          return <Option key={item.id}>{item.name[userData.locale]}</Option>
        })
        setServiceOptions(options)
      } catch (e) {
        message.error(e)
      }
      setLoaded(true)
    })()
  }, [])

  const onFinish = async (values) => {
    setLoading(true)
    console.dir(values)
    try {
      const data = {
        familyId,
        serviceId: values.serviceId,
        beginAt: values.beginAt,
        endAt: values.endAt,
        memberServiceOption: values.memberServiceOption,
      }
      await ToolRequest.request('POST', `/family-service`, data)
      message.success(I18n.t('addSuccessMessage'))
      onOk()
      setLoading(false)
    } catch (err) {
      console.dir(err)
      setLoading(false)
      if (err?.response?.data) {
        console.dir(err.response.data)
        switch (err.response.data) {
          case 'USER_SERVICE_ALREADY_EXISTS': {
            return message.error(I18n.t('家庭已綁定此服務，請勿重覆綁定'))
          }
          default:
            return message.error(I18n.t('errorMessageUnknownError'))
        }
      }

      message.error(I18n.t('errorMessageUnknownError'))
    }
  }

  return (
    <Modal
      title={I18n.t('添加家庭服務')}
      visible={visible}
      onCancel={onCancel}
      width="50%"
      maskClosable={false}
      footer={null}
    >
      {loaded ? (
        <Spin spinning={loading}>
          <Form
            form={form}
            {...formLayout}
            initialValues={
              {
                beginAt:moment()
              }
            }
            onFinish={onFinish}
          >
            <Form.Item
              label={I18n.t('服務')}
              name="serviceId"
              rules={[
                {
                  required: true
                },
              ]}
            >
              <Select
                showSearch
                placeholder={I18n.t('服務')}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={value => {
                  if(value){
                    const serviceData = services.find(item=>item.id === value)
                    if(serviceData && serviceData.duration){
                      console.dir(serviceData.duration)
                      const endAt = moment().add(serviceData.duration,'days')
                      form.setFieldsValue({endAt})
                    }else {
                      form.setFieldsValue({endAt:null})
                    }
                  }
                }}
              >
                {serviceOptions}
              </Select>
            </Form.Item>
            <Form.Item
              label={I18n.t('開始時間')}
              name="beginAt"
              required={true}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if(!value){
                      return Promise.reject(new Error(I18n.t('請輸入開始時間')));
                    }
                    const endAt = getFieldValue('endAt')
                    if(moment(value).isAfter(endAt)){
                      return Promise.reject(new Error(I18n.t('開始時間不能大於結束時間')))
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <DatePicker
                placeholder={I18n.t('開始時間')}
              />
            </Form.Item>
            <Form.Item
              label={I18n.t('結束時間')}
              name="endAt"
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if(value){
                      const beginAt = getFieldValue('beginAt')
                      if(moment(value).isBefore(beginAt)){
                        return Promise.reject(new Error(I18n.t('結束時間不能小於開始時間')))
                      }
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <DatePicker
                placeholder={I18n.t('結束時間')}
              />
            </Form.Item>
            <Form.Item
                label={I18n.t('成員服務')}
                name="memberServiceOption"
                validateStatus="error"
                help="是否在子服務中啟用該家庭的所有成員，會影響某些子服務的配額，請謹慎開啟。如之前曾加入過此服務，可選擇 ‘保持不變’，使用舊設置。要單獨設置成員子服務，可前往 家庭列表->家庭成員->成員服務列表設置"
                rules={[
                  {
                    required: true
                  },
                ]}
            >
              <Select placeholder={I18n.t('成員服務')}>
                <Option value="keep">
                  {I18n.t('保持不變')}
                </Option>
                <Option value="true">
                  {I18n.t('開啟')}
                </Option>
                <Option value="false">
                  {I18n.t('關閉')}
                </Option>
              </Select>
            </Form.Item>
            <Form.Item {...formTailLayout}>
              <Button type="primary" htmlType="submit" block>
                {I18n.t('提交')}
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      ) : <SpinFull/>}
    </Modal>
  )
};